import configureStore from "./store.util";

const configure = configureStore;

export default configure;



// WEBPACK FOOTER //
// ./src/store/configure.store.ts